import React, { Component } from 'react'
import * as common from '../../lib/common'

export default class TrangThaiView extends Component {
  constructor(props) {
    super(props);
  }
  chkApproveCLick = ({target}) => {
    this.props.chkApproveCLick(this.props.order, target.checked)
  }
  render() {
    const {
      order,
    } = this.props

    return (
      <div className="col-xs-12">
        <div>{common.getOrderMarketingStatusText(order.TrangThai, true)}</div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/MarketingOrders/_TrangThaiView.js